import { atom } from "jotai";

export type ConfirmedBookingModalType =
  | "default"
  | "recurring-request-received"
  | "recurring-request-updated";

export const confirmedBookingModalTypeAtom =
  atom<ConfirmedBookingModalType>("default");
